var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankingsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M948.571429 454.857143c35.314286 0 50.057143-45.371429 21.371428-66.285714L533.485714 71.085714a36.354286 36.354286 0 0 0-42.971428 0L54.057143 388.571429c-28.685714 20.8-13.942857 66.285714 21.485714 66.285714H146.285714v427.428571h-82.285714c-5.028571 0-9.142857 4.114286-9.142857 9.142857v59.428572c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-59.428572c0-5.028571-4.114286-9.142857-9.142857-9.142857h-82.285714V454.857143h70.857143zM512 151.657143l309.828571 225.371428H202.171429L512 151.657143zM228.571429 454.857143h133.714285v427.428571H228.571429V454.857143z m216 0h133.714285v427.428571H444.571429V454.857143z m350.857142 427.428571H660.571429V454.857143h134.857142v427.428571z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingsvg);
export default __webpack_public_path__ + "static/media/bankingsvg.dda0993d222ba7259b55ebf4dbdf1279.svg";
export { ForwardRef as ReactComponent };